import { render } from "./ParticipantDashboardView.vue?vue&type=template&id=113c53d0&scoped=true&ts=true"
import script from "./ParticipantDashboardView.vue?vue&type=script&lang=ts"
export * from "./ParticipantDashboardView.vue?vue&type=script&lang=ts"

import "./ParticipantDashboardView.vue?vue&type=style&index=0&id=113c53d0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113c53d0"]])

export default __exports__